import { Chip } from "@mui/material";
import type { MarketViewStatus } from "@/types/marketReport";

const STATUS_CONFIG: Record<
  MarketViewStatus,
  { label: string; backgroundColor: string; color: string }
> = {
  current: {
    label: "Current",
    backgroundColor: "#e6f6ef",
    color: "#0f6b45",
  },
  draft: {
    label: "Draft",
    backgroundColor: "#fff5e6",
    color: "#8a5200",
  },
  stale: {
    label: "Stale",
    backgroundColor: "#eef1f4",
    color: "#4a5565",
  },
};

export function MarketViewStatusBadge({ status }: { status: MarketViewStatus }) {
  const config = STATUS_CONFIG[status];

  return (
    <Chip
      label={config.label}
      size="small"
      sx={{
        backgroundColor: config.backgroundColor,
        color: config.color,
        borderRadius: "999px",
        fontWeight: 500,
        fontSize: "0.76rem",
        letterSpacing: 0,
      }}
    />
  );
}
